import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Usuario } from '../../../../usuario/usuario';

@Component({
    selector: 'sgt-cliente-baixa-card-info',
    templateUrl: './cliente-baixa-card-info.component.html',
    styleUrls: ['./cliente-baixa-card-info.component.less']
})
export class ClienteBaixaCardInfoComponent implements OnInit, AfterViewInit {
    @Input() title = 'Dados da Baixa';
    @Input() dataBaixa: Date;
    @Input() baixaManual: boolean;
    @Input() usuarioBaixa: Usuario;
    @Input() motivoBaixa: string;

    @Input() isCollapseOpenedDefault = true;
    isCollapseOpened: boolean;

    @Output() afterOpen = new EventEmitter();
    @Output() afterClose = new EventEmitter();

    @ViewChild('collapse') collapse: ElementRef;

    ngOnInit() {
        this.isCollapseOpened = this.isCollapseOpenedDefault;
    }

    ngAfterViewInit() {
        if (!this.isCollapseOpenedDefault) {
            jQuery(this.collapse.nativeElement).css('display', 'none');
        }
    }


    /** Abre/Fecha o collapse */
    async toggleCollapse(): Promise<void> {
        return new Promise<any>(async (resolve) => {
            this.isCollapseOpened = !this.isCollapseOpened;
            if (this.isCollapseOpened) {
                return await this.open();
            }

            return await this.close();
        });
    }

    /** Abre o collapse */
    async open(): Promise<void> {
        return new Promise<void>((resolve) => {
            this.isCollapseOpened = true;
            jQuery(this.collapse.nativeElement).slideDown(400, () => {
                this.afterOpen.emit();
                resolve();
            });
        });
    }

    /** Fecha o collapse */
    close(): Promise<void> {
        return new Promise<void>((resolve) => {
            this.isCollapseOpened = false;
            jQuery(this.collapse.nativeElement).slideUp(400, () => {
                this.afterClose.emit();
                resolve();
            });
        });
    }
}
